/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BillingTablePartitionDeleteSpec { 
    /**
     * The partition which is to be dropped
     */
    partition_name?: string;
    /**
     * The table for which partitions are to be dropped
     */
    table_name?: string;
}

